<div class="fou-ufda-notice-wrap">
    <div data-qa-id="ufda2-singing" class="fou-ufda-notice">
        <div data-qa-id="message" class="fou-ufda-notice__text">
            <h4 data-qa-id="title" class="mt-e-title" v-if="contractSummaryTypeTitle">
                {{ $t(`pages.dashboard.components.ufda2Agreement.${agrrementsPermission}.permitted_title`) }}
            </h4>
            <h4 data-qa-id="title" class="mt-e-title" v-else>
                {{ $t(`pages.dashboard.components.ufda2Agreement.${agrrementsPermission}.legacy_title`) }}
            </h4>
            <p data-qa-id="desc" class="mt-e-para" v-if="contractSummary === 'UFDA'"
                v-html="$t(`pages.dashboard.components.ufda2Agreement.${agrrementsPermission}.ufda_desc`)">
            </p>
            <p data-qa-id="desc" class="mt-e-para"
                v-else-if="contractSummaryTypeDesc"
                v-html="$t(`pages.dashboard.components.ufda2Agreement.${agrrementsPermission}.monotypeip_desc`)">
            </p>
            <p data-qa-id="desc" class="mt-e-para" v-else
                v-html="$t(`pages.dashboard.components.ufda2Agreement.${agrrementsPermission}.legacy_desc`)">
            </p>
        </div>
        <button data-qa-id="button" :class="['mt-btn--taco', { 'mt-btn--disabled': !hasAgreementsPermission }]"
            :disabled="!hasAgreementsPermission" @click="hasAgreementsPermission && gotoAgreements()">
            <span :class="[gotoAgreementsIconClass]" />
            {{ $t('pages.dashboard.components.ufda2Agreement.button') }}
        </button>
    </div>
</div>